/*
 * @Desc: 积分兑换比例
 * @Author: zhangying
 * @Date: 2026-01-15
 */
import request from "@/utils/request";
const pointsconfig = {
  // 详情
  detail(query) {
    return request({
      url: "/pointsconfig/detail",
      method: "post",
      params: query
    });
  },
  // 标记成交
  edit(query) {
    return request({
      url: "/pointsconfig/edit",
      method: "post",
      params: query
    });
  },
};
export default pointsconfig;
